// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"187":"effa8239","969":"e175ce31"}[chunkId] + ".chunk.css";
};